export const Columns = ({ className, count, children }) => {
  return (
    <div
      className={[count ? 'content-columns' : 'columns', className]
        .filter(Boolean)
        .join(' ')}
      style={{
        '--count': count,
      }}
    >
      {children}
    </div>
  );
};

export const Column = ({ className, children }) => {
  return (
    <div className={['column', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
};
